var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-avatar',_vm._g(_vm._b({staticClass:"estilo-avatar me-3 white--text",style:({ backgroundColor: _vm.corBackground }),attrs:{"color":_vm.corBackground,"size":"21"}},'v-avatar',attrs,false),on),[_vm._v(" "+_vm._s(_vm.labelBotao)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.texto))])])}
var staticRenderFns = []

export { render, staticRenderFns }